import { render, staticRenderFns } from "./product_detail.vue?vue&type=template&id=07478298&scoped=true&"
import script from "./product_detail.vue?vue&type=script&lang=js&"
export * from "./product_detail.vue?vue&type=script&lang=js&"
import style0 from "./product_detail.vue?vue&type=style&index=0&lang=less&"
import style1 from "./product_detail.vue?vue&type=style&index=1&id=07478298&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07478298",
  null
  
)

export default component.exports